import { Injectable } from '@angular/core';

import { IBetslipState } from '../../../../../base/store/state';
import { BetslipType } from '../../../../../core/betslip-type';
import { BetslipValidationContext } from '../../../models/models';
import { TypeContextGeneratorService } from './type-context-generator.service';

@Injectable()
export class BetslipContextGeneratorService {
    constructor(private typeContextGenerator: TypeContextGeneratorService) {}

    generateContext(state: IBetslipState): BetslipValidationContext {
        const systemPicks = Object.values(state.types.systemBet.picks);

        const isEditBet = state.types.base.currentSelectedType === BetslipType.EditBet;

        return {
            comboBet: {
                picksCount: Object.values(state.types.comboBet.picks).length,
            },
            teaserBet: {
                picksCount: Object.values(state.types.teaserBet.picks).length,
            },
            systemBet: {
                picksCount: systemPicks.length,
                selectedPicks: systemPicks.filter((x) => x.isSelected),
            },
            editBet: isEditBet ? this.typeContextGenerator.generateEditBetContext(state.types.editBet) : undefined,
        };
    }
}
